import React from 'react';
import { Link } from 'react-router-dom';

const OlympicsDetailsPage: React.FC = () => {
  return (
    <div className="container my-5">
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <h1 className="text-center mb-3">2026 Winter Olympics Outreach</h1>
          <p className="text-center text-muted mb-4">Milan and Cortina d'Ampezzo, Italy • February 6-16, 2026</p>

          <div className="alert alert-info text-center mb-4">
            <strong>Join us in Italy for the 2026 Winter Olympics</strong>
            <br />
            Come share God's Word with the world during this historic event!
          </div>

          <div className="card mb-4">
            <div className="card-body">
              <h4>Event Dates & Options</h4>
              <ul>
                <li><strong>Week 1:</strong> February 6-14, 2026</li>
                <li><strong>Week 2:</strong> February 13-21, 2026</li>
                <li><strong>Both Weeks:</strong> February 6-21, 2026</li>
              </ul>
              <p className="mb-0">Sign up for one week or two weeks via the online application.</p>
            </div>
          </div>

          <div className="card mb-4">
            <div className="card-body">
              <h4>Registration Options</h4>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <div className="border rounded p-3 h-100">
                    <h5>One Week</h5>
                    <p className="fs-4 fw-bold text-primary">~$3,200</p>
                    <small>Per person</small>
                    <ul className="mt-2 small">
                      <li>Airfare</li>
                      <li>Transportation</li>
                      <li>Lodging</li>
                      <li>Meals</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="border rounded p-3 h-100">
                    <h5>Two Weeks</h5>
                    <p className="fs-4 fw-bold text-primary">~$4,700</p>
                    <small>Per person</small>
                    <ul className="mt-2 small">
                      <li>Airfare</li>
                      <li>Transportation</li>
                      <li>Lodging</li>
                      <li>Meals</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="alert alert-warning mt-3 mb-0">
                <strong>Note:</strong> Costs are approximate and subject to change based on final arrangements.
              </div>
            </div>
          </div>

          <div className="card mb-4">
            <div className="card-body">
              <h4>Deposit & Payment</h4>
              <p><strong>Deposit:</strong> $200 per person (non-refundable, applied to total cost)</p>
              <p className="mb-1"><strong>Mail deposit to:</strong><br />
              Hillcrest Baptist Church<br />
              6069 Woodstock Rd<br />
              Acworth, GA 30102</p>
              <p className="mb-0 mt-2"><em>Make check payable to <strong>Hillcrest Baptist Church</strong> and include your name in the memo.</em></p>
            </div>
          </div>

          <div className="card mb-4">
            <div className="card-body">
              <h4>Important Requirements</h4>
              <div className="alert alert-danger mb-0">
                <strong>Passport Required:</strong> Apply for or confirm your passport now. It must be valid through August 2026.
              </div>
            </div>
          </div>

          <div className="card mb-4">
            <div className="card-body">
              <h4>Contact Information</h4>
              <p><strong>David Hardin</strong><br />
              Director, Outreach Bible Project<br />
              Phone: <a href="tel:770-906-7795">770-906-7795</a><br />
              Email: <a href="mailto:David_OBP@outlook.com">David_OBP@outlook.com</a></p>
            </div>
          </div>

          <div className="text-center mb-4">
            <Link to="/events/olympics-2026/apply" className="btn btn-success btn-lg me-3">
              <i className="fas fa-clipboard-check me-2" aria-hidden></i>
              Register / Apply
            </Link>
            <a href="/docs/Milano_Italy_2026_Save_the_date.txt" className="btn btn-outline-secondary btn-lg" target="_blank" rel="noopener noreferrer">
              <i className="fas fa-download me-2" aria-hidden></i>
              Download Save-the-Date
            </a>
          </div>

          <div className="card">
            <div className="card-body">
              <h5>Additional Information</h5>
              <ul>
                <li>Choose to attend one week or both weeks when completing your application</li>
                <li>Deposit is non-refundable but will be applied to your total cost</li>
                <li>Final costs may vary based on airfare and accommodation arrangements</li>
                <li>Early registration is encouraged as space may be limited</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OlympicsDetailsPage;
